<template>
  <div>
    <breadcrumbs class="bg-light text-muted"></breadcrumbs>
    <integration-list class="p-5"></integration-list>
  </div>
</template>

<script>
  import IntegrationList from '@/components/administration/integration/common/IntegrationList'
  import Breadcrumbs from '@/components/common/Breadcrumbs'

  export default {
    metaInfo: {
      title: 'Integrations'
    },

    components: {
      'breadcrumbs': Breadcrumbs,
      'integration-list': IntegrationList
    }
  }
</script>
